export default __webpack_public_path__ + "static/media/BhaskarLogo.1c2a8b99.png";